import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { Card, MapView, Text } from "../../../components";
import Localization from "../../../localization";
import styled from "styled-components";
import { Flex } from "antd";

const Styled = styled(Card)`
  background-color: ${(_) =>
    _.isUnConfigured && _.theme.token.alerts.error.background};
`;

const DeviceCard = ({
  center,
  name = "",
  title = "",
  isCardMissing,
  isUnConfigured,
  active = false,
  className = "",
  onClick = () => {},
}) => {
  return (
    <Styled
      hoverable
      onClick={onClick}
      classNames={{ body: "p-0" }}
      isUnConfigured={isUnConfigured}
      className={`${className} overflow-hidden`}
    >
      <MapView
        zoom={18}
        center={center}
        style={{ height: "200px" }}
        markers={[{ position: center }]}
        options={{
          disableDefaultUI: true,
          disableDoubleClickZoom: true,
          scaleControl: false,
          gestureHandling: "none",
          scrollwheel: false,
        }}
      />
      <div style={{ padding: "2rem 2.5rem 2.5rem" }}>
        <Flex justify="space-between">
          <Text
            level={5}
            weight={700}
            children={title}
            type={active ? "primary" : "disabled"}
          />
          {isUnConfigured ? (
            <Text weight={600}>
              <CloseCircleFilled />
              {` ${Localization.general.inactive}`}
            </Text>
          ) : (
            <Text weight={600} type={active ? "secondary" : "disabled"}>
              {active ? <CheckCircleFilled /> : <CloseCircleFilled />}
              {` ${
                active
                  ? Localization.general.active
                  : Localization.general.inactive
              }`}
            </Text>
          )}
        </Flex>
        {(isCardMissing || isUnConfigured) && (
          <Text
            weight={400}
            size={"1.1rem"}
            className="m-3-t"
            type={isUnConfigured ? "primary" : "secondary"}
            children={
              isUnConfigured
                ? Localization.dashboard.device_notconfig_desc
                : Localization.dashboard.device_missing_card_desc
            }
          />
        )}
        <Text
          level={4}
          weight={700}
          className="m-15-t"
          lineHeight="normal"
          children={name}
          type={
            active ? (isUnConfigured ? "primary" : "secondary") : "disabled"
          }
        />
      </div>
    </Styled>
  );
};

export default DeviceCard;
